import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Marks an `<ng-template>` as the custom option renderer for `adminui-select`.
 * Context: `$implicit` = the option object.
 *
 * ```html
 * <adminui-select [options]="years" optionLabel="label">
 *   <ng-template adminuiSelectOption let-option>
 *     <span [title]="option.label">{{ option.label }}</span>
 *   </ng-template>
 * </adminui-select>
 * ```
 */
@Directive({
  selector: '[adminuiSelectOption]',
  standalone: true
})
export class AdminuiSelectOptionDirective {
  readonly template = inject(TemplateRef<{ $implicit: any }>);
}
